export default __webpack_public_path__ + "static/media/GochungTso.c3bf70fe.webp";